import { atom } from 'jotai';
import { Nullable } from '@/types/generic';

export const playerIdAtom = atom<Nullable<number>>(null);

// unlike `playerIdAtom`, this atom globally tracks the last selected player id, outside the scope of any specific page/section.
export const globalPlayerIdAtom = atom<Nullable<number>>(null);

// This atom is set to true when the user first selects a player who is not the default player for the first time.
export const hasUserSelectedPlayerAtom = atom<boolean>(false);
